import {NeedsReviewReason, PayinStatus} from '@sollapay/enums';

import {PayinNotReviewableError} from '../errors';

import type {PayinEntity} from '@sollapay/domain/entities';

const APPROVABLE_REASONS: readonly NeedsReviewReason[] = [
  NeedsReviewReason.LOW_CONFIDENCE_MATCH,
  NeedsReviewReason.AI_SUGGESTED_MATCH
];

export class PayinReviewPolicy {
  /**
   * Approval settles the payin against its linked instruction unconditionally, so it
   * must only ever apply to a genuinely uncertain match. NEEDS_REVIEW also covers
   * INSTRUCTION_NOT_ALLOCATABLE — the instruction was identified correctly but its
   * current status (terminal or otherwise) means it must not receive funds — and
   * approving that would settle money against an instruction that should never be
   * settled. Rejection has no such restriction: reverting to UNMATCHED is safe
   * regardless of why the match couldn't auto-allocate.
   */
  static assertCanApprove({payin}: {payin: PayinEntity}): void {
    this.assertReviewable(payin);
    if (!payin.needsReviewReason || !APPROVABLE_REASONS.includes(payin.needsReviewReason)) {
      throw new PayinNotReviewableError(
        `Payin ${payin.id} cannot be approved — reason is ${payin.needsReviewReason}, not an uncertain match`
      );
    }
  }

  static assertCanReject({payin}: {payin: PayinEntity}): void {
    this.assertReviewable(payin);
  }

  private static assertReviewable(payin: PayinEntity): void {
    if (payin.status !== PayinStatus.NEEDS_REVIEW) {
      throw new PayinNotReviewableError(`Payin is not reviewable from status ${payin.status}`);
    }
  }
}
